<div class="row">
	<div class="col-sm">
		<div class="form-group">
			<label for="productList-input" class="form-label">Producto</label>
			<div class="input-group">
				<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.productList"
					[placeholder]="'Ingresa el nombre o código de barras de un producto'"
					[filterElements]="filterProductList" [typeElements]="'product'"
					(inputMethod)="writeProduct($event.event,'client')" [custom]="true"
					(changeStatus)="selectProduct($event.filterElement,$event.filterElement.name,1,'product')">
					<ng-template #itemsTemplate let-filter>
						<!-- This is the content that will be projected -->
						<div items class="fieldg">
							<div class="row" style="margin:0;">
								<span class="col valg-span">
									{{filter.name}}
								</span>
								<span class="col">
									<b><i class="fa fa-key"></i></b>{{filter.code}}
								</span>
								<span class="col">
									<b><i class="fa fa-barcode"></i></b>{{filter.barCode}}
								</span>
							</div>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
		<div *ngIf="priceList.length > 0" class="table-container table-responsive">
			<table class="table table-striped">
				<thead>
					<tr>
						<th scope="col">Producto</th>
						<th scope="col" class="td-center">Precios</th>
						<th scope="col" *ngIf="editCost" class="td-center">Costo</th>
						<th scope="col"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let price of priceList">
						<td>{{price.product}}</td>
						<td>
							<table class="table mb-0" *ngIf="price.priceList">
								<thead>
									<th>Nombre</th>
									<th class="td-center">Precio</th>
								</thead>
								<tbody>
									<tr *ngFor="let list of price.priceList">
										<td>{{list.listData.name}}</td>
										<td class="td-center">{{list.price}}</td>
									</tr>
								</tbody>
							</table>
							<p class="muted text-center" *ngIf="!price.priceList || price.priceList.length == 0"><i class="fa fa-box-open"></i>SIN LISTAS</p>
						</td>
						<td class="td-center" *ngIf="editCost">
							<div>
								{{price.cost | currency: 'Q'}}
								<i tooltip="Cambiar costo" *ngIf="editing != price.product_id" class="fa fa-arrows-rotate text-info clickeable"
									(click)="changeCost(price)"></i>
							</div>
							<div class="input-group" *ngIf="editing === price.product_id">
								<input type="number" placeholder="Ingresa el costo del producto" class="form-control" name="cost{{price.product_id}}"
									id="cost{{price.product_id}}" [(ngModel)]="price.cost">
								<button class="btn btn-success" [disabled]="price.loading" (click)="saveCost(price)">
									<i class="fa fa-save" *ngIf="!price.loading"></i>
									<app-loading-animation *ngIf="price.loading" [color]="'white'" [height]="'1rem'"></app-loading-animation>
								</button>
								<button class="btn btn-info" (click)="editing = null; price.cost = null;"><i
										class="fa fa-xmark"></i></button>
							</div>
						</td>
						<td class="td-center">
							<span class="clickeable text-danger" (click)="deleteProductList(price.product_id)">
								<i class="fa fa-trash"></i>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>